(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sticky-add-to-cart-bar"] && !Shopify.designMode) return;
  try {
    class StickyAddToCartBar extends HTMLElement {
    constructor() {
      super();
      this.scrollTarget = this.dataset.scrollTarget || '[data-variants-table]';
      this.scrollButton = this.querySelector('[data-scroll-button]');
      this.metafieldsContainer = this.querySelector('[data-metafields-container]');
      this.triggerElement = null;
      this.isVisible = false;
      this.config = null;
      
      this.init();
    }
    
    init() {
      // Load config from JSON
      this.loadConfig();
      
      // Find the trigger element (variant table or product form)
      this.triggerElement = document.querySelector(this.scrollTarget);
      
      if (!this.triggerElement) {
        // Fallback to product form if target not found
        this.triggerElement = document.querySelector('product-form-component, .product-form');
      }
      
      if (this.triggerElement) {
        this.setupIntersectionObserver();
      }
      
      // Setup scroll button
      if (this.scrollButton) {
        this.scrollButton.addEventListener('click', () => this.scrollToTarget());
      }
      
      // Listen for variant row clicks from implant-selector
      this.setupVariantListener();
    }
    
    loadConfig() {
      const configScript = this.querySelector('[data-sticky-bar-config]');
      if (configScript) {
        try {
          this.config = JSON.parse(configScript.textContent);
        } catch (e) {
          console.warn('Could not parse sticky bar config');
          this.config = { metafields: {}, variants: [] };
        }
      }
    }
    
    setupVariantListener() {
      // Listen for clicks on variant table rows
      document.addEventListener('click', (event) => {
        const row = event.target.closest('.implant-table__row');
        if (row) {
          const variantId = row.dataset.variantId;
          if (variantId) {
            this.updateMetafieldsForVariant(variantId);
          }
        }
      });
      
      // Listen for ImplantVariantChange event (dispatched by implant-selector on platform change)
      document.addEventListener('ImplantVariantChange', (event) => {
        const variantId = event.detail?.variantId;
        if (variantId) {
          this.updateMetafieldsForVariant(variantId);
        }
      });
    }
    
    updateMetafieldsForVariant(variantId) {
      if (!this.config || !this.config.variants || !this.metafieldsContainer) return;
      
      const variant = this.config.variants.find(v => v.id.toString() === variantId.toString());
      if (!variant || !variant.metafields) return;
      
      const metafieldKeys = ['meta1', 'meta2', 'meta3', 'meta4'];
      
      metafieldKeys.forEach((key) => {
        const settingKey = this.config.metafields[key];
        if (!settingKey) return;
        
        const metafieldItem = this.metafieldsContainer.querySelector(`[data-metafield-key="${settingKey}"]`);
        if (!metafieldItem) return;
        
        const valueSpan = metafieldItem.querySelector('[data-metafield-value]');
        if (!valueSpan) return;
        
        const newValue = variant.metafields[key];
        if (newValue !== null && newValue !== undefined && newValue !== '') {
          const capitalizedValue = typeof newValue === 'string' 
            ? newValue.charAt(0).toUpperCase() + newValue.slice(1) 
            : newValue;
          valueSpan.textContent = capitalizedValue;
          metafieldItem.classList.remove('is-hidden');
        } else {
          valueSpan.textContent = '';
          metafieldItem.classList.add('is-hidden');
        }
      });
    }
    
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // Show bar when trigger element is NOT visible (scrolled past it)
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            this.show();
          } else {
            this.hide();
          }
        });
      }, options);
      
      this.observer.observe(this.triggerElement);
    }
    
    show() {
      if (!this.isVisible) {
        this.isVisible = true;
        this.classList.add('is-visible');
      }
    }
    
    hide() {
      if (this.isVisible) {
        this.isVisible = false;
        this.classList.remove('is-visible');
      }
    }
    
    scrollToTarget() {
      const target = document.querySelector(this.scrollTarget);
      if (target) {
        const headerOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0');
        const customOffset = parseInt(this.dataset.scrollOffset || '100');
        const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset - customOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
    
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }
  
  if (!customElements.get('sticky-add-to-cart-bar')) {
    customElements.define('sticky-add-to-cart-bar', StickyAddToCartBar);
  }
  } catch(e) { console.error(e); }
})();

})();
